var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadminton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.2,106.4l25.5-25.5l-7.3-7.3L21.9,99.1c-2,2-2,5.3,0,7.3C24,108.4,27.2,108.4,29.2,106.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,82.8L9.2,130.1c-2,2-2,5.3,0,7.3s5.3,2,7.3,0l47.3-47.3L56.5,82.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1602 -0.9871 0.9871 0.1602 37.24 110.5704)",
    cx: 83.6,
    cy: 33.4,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.1,46.3H51.6L39.5,34.2l8.8-8.8c1.2,0.8,2.7,1.2,4.4,1.2c0.5,0,1,0,1.6-0.1c2.9-0.4,5.8-2,8-4.2s3.8-5,4.2-8 c0.4-2.9-0.3-5.4-2-7c-1.3-1.3-3.2-2.1-5.4-2.1c-0.5,0-1,0-1.6,0.1c-2.9,0.4-5.8,2-8,4.2s-3.8,5-4.2,8c-0.4,2.3,0.1,4.4,1.1,6l-9,9 c-2-1.1-4.5-0.8-6.2,0.8c-2,2-2,5.3,0,7.3l14.5,14.5c1,1,2.3,1.5,3.6,1.5h15L51,70.1l16.4,16.4l29.9-29.9h33.9 c2.8,0,5.1-2.3,5.1-5.1C136.3,48.6,134,46.3,131.1,46.3z M48.1,17.9c0.3-2.2,1.6-4.6,3.5-6.5s4.2-3.1,6.5-3.5 c0.4-0.1,0.8-0.1,1.2-0.1c1.5,0,2.7,0.4,3.5,1.3c1.1,1.1,1.5,2.7,1.2,4.7c-0.3,2.2-1.6,4.6-3.5,6.5s-4.2,3.1-6.5,3.5 c-0.4,0.1-0.8,0.1-1.2,0.1c-1.5,0-2.7-0.4-3.5-1.3C48.2,21.5,47.8,19.8,48.1,17.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,12.5c-0.4,0.2-0.7,0.4-1,0.7c-0.3,0.3-0.5,0.6-0.7,1s-0.3,0.8-0.3,1.3s0.1,0.9,0.3,1.3s0.4,0.7,0.7,1s0.6,0.5,1,0.7 l12.2,4.1V8.4L124.1,12.5z M133.6,18.7l-8.5-2.9c0,0-0.1,0-0.1-0.1c0,0-0.1-0.1-0.1-0.2s0-0.1,0-0.2s0-0.1,0-0.2s0.1-0.1,0.1-0.2 l0.1-0.1l8.5-2.9V18.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadminton);
export default __webpack_public_path__ + "static/media/badminton.c83b684ba7b1c62898fa12d5e4a4c460.svg";
export { ForwardRef as ReactComponent };